module.exports = __webpack_public_path__ + "images/fae4b86139a6686e3051552923eaba8e.woff";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/syrcomadiabene.woff
// module id = 1149
// module chunks = 0